module.exports = __webpack_public_path__ + "img/the_book_you_wish_your_parent.e017269a.jpg";